module.exports = __webpack_public_path__ + "img/1f9b8-1f3fd-200d-2640-fe0f.62d3df4.svg";